const state = () => ({
  isValid: false,
  currentPassword: '',
  newPassword: '',
  currentPasswordValidation: true,
  currentPasswordError: '',
  newPasswordError: false
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  currentPassword(state) {
    return state.currentPassword;
  },
  newPassword(state) {
    return state.newPassword;
  },
  currentPasswordValidation(state) {
    return state.currentPasswordValidation;
  },
  currentPasswordError(state) {
    return state.currentPasswordError;
  },
  newPasswordError(state) {
    return state.newPasswordError;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateCurrentPassword(state, payload) {
    state.currentPassword = payload;
  },
  updateNewPassword(state, payload) {
    state.newPassword = payload;
  },
  setCurrentPasswordValidation(state, payload) {
    state.currentPasswordValidation = payload;
  },
  setCurrentPasswordError(state, payload) {
    state.currentPasswordError = payload;
  },
  setNewPasswordError(state, payload) {
    state.newPasswordError = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  updateCurrentPassword({ commit }, payload) {
    commit('updateCurrentPassword', payload);
  },
  updateNewPassword({ commit }, payload) {
    commit('updateNewPassword', payload);
  },
  setCurrentPasswordValidation({ commit }, payload) {
    commit('setCurrentPasswordValidation', payload);
  },
  setCurrentPasswordError({ commit }, payload) {
    commit('setCurrentPasswordError', payload);
  },
  setNewPasswordError({ commit }, payload) {
    commit('setNewPasswordError', payload);
  }
};

export const updatePassword = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
